import { render, staticRenderFns } from "./CytomineLazyTable.vue?vue&type=template&id=2945f9b2"
import script from "./CytomineLazyTable.vue?vue&type=script&lang=js"
export * from "./CytomineLazyTable.vue?vue&type=script&lang=js"
import style0 from "./CytomineLazyTable.vue?vue&type=style&index=0&id=2945f9b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports